<template>
  <div>
    <div
      class="b-server-error mb-4 b-server-error_type_duplicate"
    >
      <div class="b-server-error__icon-wrap b-server-error__icon-wrap_type_duplicate p-4">
        <dynamic-icon icon="warning" />
      </div>
      <div class="b-server-error__inner-wrap">
        <div class="b-server-error__text-wrap px-4">
          <span>
            {{ $t('CONTENT.importData.contracts_with_new_discountRate_download_text') }} &nbsp;
          </span>
          <button
            class="b-import__template-btn"
            @click.prevent="contractsForRecalculationDownloadExcel"
          >
            {{ $t('CONTENT.importData.contracts_with_new_discountRate_download_btn') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="containsContractsWithMixedDiscountRates"
      class="b-server-error mb-4 b-server-error_type_duplicate"
    >
      <div class="b-server-error__icon-wrap b-server-error__icon-wrap_type_duplicate p-4">
        <dynamic-icon icon="warning" />
      </div>
      <div class="b-server-error__inner-wrap">
        <div class="b-server-error__text-wrap px-4">
          <span>
            {{ $t('CONTENT.importData.contracts_with_mixed_discount_rate_types_download_text') }} &nbsp;
          </span>
          <button
            class="b-import__template-btn"
            @click.prevent="contractsWithMixedDiscountRateTypesDownloadExcel"
          >
            {{ $t('CONTENT.importData.contracts_with_new_discountRate_download_btn') }}
          </button>
        </div>
      </div>
    </div>
    <div
      class="b-import__save-button mt-4"
    >
      <div class="col-6 offset-6">
        <div
          class="b-form__container b-form__container_type_flex b-form__container_type_flex_end"
        >
          <button
            data-cy="save-create-asset"
            class="b-btn b-btn_type_primary"
            type="button"
            @click="saveContracts"
          >
            {{ $t('CONTENT.continue') }}
          </button>
          <button
            data-cy="cancel-create-asset"
            type="text"
            class="b-btn b-btn_type_empty m-2"
            @click="cancelSave"
          >
            {{ $t('CONTENT.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    saveContracts: Function,
    contractsForRecalculationDownloadExcel: Function,
    contractsWithMixedDiscountRateTypesDownloadExcel: Function,
    cancelSave: Function,
    containsContractsWithMixedDiscountRates: Boolean,
  },
};
</script>
